import '@patsnap-ui/icon/assets/solid/ArrowRight.svg'
import '@patsnap-ui/icon/assets/solid/CircleClose.svg'
import '@patsnap-ui/icon/assets/solid/feedback.svg'
import '@patsnap-ui/icon/assets/solid/onlineConsult.svg'
import '@patsnap-ui/icon/assets/solid/wechatService.svg'
import operatorWechatImg from '@pharmsnap/pharmsnap-web/assets/img/operatorWechat.png'
import workWechatImg from '@pharmsnap/pharmsnap-web/assets/img/workWechat.png'
import { useCopilotChatStore } from '@pharmsnap/pharmsnap-web/composable/useCopilotChatStore'
import { useAuthStore } from '@pharmsnap/shared/src/composition'
import { defineComponent, getCurrentInstance, ref } from '@vue/composition-api'
import { HelpService } from 'patsnap-biz'
import FeedbackDialog from '../Feedback/FeedbackDialog/FeedbackDialog'
import FeedbackSuccessDialog from '../Feedback/FeedbackSuccessDialog/FeedbackSuccessDialog'
import $class from './ServiceHelp.module.scss'

export const ServiceHelp = defineComponent({
  name: 'HelpService',
  props: {},
  setup(props) {
    const {
      getters: { isFreeUser },
    } = useAuthStore()
    const ins = getCurrentInstance()
    const {
      state: { dialogVisible: ls360DialogVisible },
    } = useCopilotChatStore()
    const feedbackDialogVisible = ref(false)
    const feedbackSuccessDialogVisible = ref(false)
    const QIYUDOM = '#YSF-BTN-HOLDER'
    const menu = [
      {
        title: ins?.proxy.$t('helpMenu.onlineConsult'),
        icon: 'SolidOnlineConsult',
        show: true,
        clickHandler: () => {
          if (isFreeUser.value) return
          const qiyuBtn = document.querySelector<HTMLElement>(QIYUDOM)
          if (qiyuBtn) {
            if (document.all) {
              qiyuBtn.click()
            } else {
              const event = document.createEvent('MouseEvents')
              event.initEvent('click', true, true)
              qiyuBtn.dispatchEvent(event)
            }
          }
        },
      },
      {
        title: ins?.proxy.$t('helpMenu.wechatService'),
        icon: 'SolidWechatService',
        qrImage: operatorWechatImg,
        qrTitle: ins?.proxy.$t('helpMenu.qrTitle'),
        slotName: 'wechatService',
        show: !isFreeUser.value,
      },
    ].filter((item) => item.show)

    // 免费用户点击直接显示反馈弹窗
    const handleHelpServiceClick = () => {
      if (isFreeUser.value) {
        feedbackDialogVisible.value = true
      }
    }

    return {
      isFreeUser,
      menu,
      feedbackDialogVisible,
      feedbackSuccessDialogVisible,
      ls360DialogVisible,
      handleHelpServiceClick,
    }
  },
  methods: {
    renderFeedbackDialog() {
      return (
        <FeedbackDialog
          visible={this.feedbackDialogVisible}
          onClose={() => {
            this.feedbackDialogVisible = false
          }}
          onSubmitSuccess={() => {
            this.feedbackSuccessDialogVisible = true
          }}
        ></FeedbackDialog>
      )
    },
    renderFeedbackSuccessDialog() {
      return (
        <FeedbackSuccessDialog
          onClose={() => (this.feedbackSuccessDialogVisible = false)}
          visible={this.feedbackSuccessDialogVisible}
        ></FeedbackSuccessDialog>
      )
    },
  },
  render() {
    return (
      <div class="select-none" v-show={!this.ls360DialogVisible}>
        {/* 盖过el-backtop */}
        <div class="fixed bottom-4 right-6 z-[6]">
          <HelpService
            class={$class.helpService}
            onClickHelpService={this.handleHelpServiceClick}
            menu={this.isFreeUser ? [] : this.menu}
            entryText={this.isFreeUser ? this.$t('helpMenu.feedback') : this.$t('helpMenu.help&service')}
            scopedSlots={{
              wechatService: ({ item }: { item: { qrDesc: string; qrTitle: string } }) => (
                <div class="w-[108px] flex flex-col items-center">
                  <img src={this.isFreeUser ? operatorWechatImg : workWechatImg} alt="qrCode" />
                  <div class="font-semibold mt-1">{item.qrTitle}</div>
                  <div class="">{this.$t('helpMenu.qrDescOne')}</div>
                  <div class="">{this.$t('helpMenu.qrDescTwo')}</div>
                  <div class="">{this.$t('helpMenu.qrDescThree')}</div>
                </div>
              ),
            }}
          ></HelpService>
        </div>
        {this.renderFeedbackDialog()}
        {this.renderFeedbackSuccessDialog()}
      </div>
    )
  },
})
